function hashChangeHandler() {
  const hashData = window.location.hash
  if (hashData) {
    const idElement = document.querySelector(hashData) as HTMLElement;
    if (idElement && hashData.includes("footnote")) {
      const triggerHeaderElement = document.querySelector('.footnote-section__header') as HTMLElement;
      if (triggerHeaderElement.getAttribute('aria-expanded') !== 'true') {
        triggerHeaderElement.click();
      }
      idElement.setAttribute("tabindex", "0");
      idElement.focus();
    }
    idElement?.scrollIntoView({ behavior: 'smooth' });   
    history.replaceState(null, '', window.location.pathname + window.location.search); 
  }
}

export default hashChangeHandler;
